/* eslint-disable no-useless-escape */
const youtubeRegex =
    /<iframe[^>]*?src=\"(https:\/\/www\.youtube(?:-nocookie)?\.com\/embed\/[^"]*)(?:(?!<\/iframe>).)+<\/iframe>/gim;
const vimeoRegex = /<iframe[^>]*?src=\"(https:\/\/player\.vimeo\.com\/video\/[^"]*)(?:(?!<\/iframe>).)+<\/iframe>/gim;

function replaceIframes(string) {
    if (!string || typeof string !== "string" || !string.includes("<iframe")) {
        return string;
    }

    if (string.includes("https://www.youtube.com/embed") || string.includes("https://www.youtube-nocookie.com/embed")) {
        const youtubeIframeMatcher = [...string.matchAll(youtubeRegex)];
        for (const data of youtubeIframeMatcher) {
            const { iframe, videoID } = getDataFromArray(data);
            if (iframe && videoID) {
                const markup = video(videoID, "youtube");
                string = string.replace(iframe, markup);
            }
        }
    }

    if (string.includes("https://player.vimeo.com/video")) {
        const vimeoIframeMatcher = [...string.matchAll(vimeoRegex)];
        for (const data of vimeoIframeMatcher) {
            const { iframe, videoID } = getDataFromArray(data);
            if (iframe && videoID) {
                const markup = video(videoID, "vimeo");
                string = string.replace(iframe, markup);
            }
        }
    }

    return string;
}

function getDataFromArray(data) {
    const iframe = data[0];
    const url = data[1];
    if (!iframe || !url) {
        return {};
    }
    const videoID = url.split("/").pop();
    if (!videoID) {
        return {};
    }
    return { videoID, iframe, url };
}

const playButton =
    '<svg aria-hidden="true" focusable="false" role="img" class="pointer-events-none absolute left-1/2 top-1/2 z-10 block h-[72px] w-[72px] -translate-x-1/2 -translate-y-1/2 scale-[0.8] text-white opacity-90 transition group-active:scale-90 group-hocus:scale-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"><circle class="fill-black/40 stroke-[5]" stroke="currentColor" cx="36" cy="36" r="33"></circle><path fill="currentColor" fill-rule="nonzero" d="M51.489 39.17L28.247 52.506c-2.087 1.162-4.715-.33-4.715-2.773V22.266c0-2.43 2.615-3.935 4.715-2.773l23.242 14.13c2.165 1.215 2.165 4.345 0 5.546z"></path></svg>';
const image =
    '<img x-bind="img" loading="lazy" alt="Vorschaubild vom Video" class="block h-auto max-w-none w-full object-cover aspect-video" />';
const iframe =
    '<template x-if="playing"><iframe class="border-0 aspect-video !max-w-none w-full" :src="src" allowfullscreen frameborder="0" allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe></template>';

function video(id, type) {
    return `<div x-data="${type}('${id}')" class="relative aspect-video w-full max-w-full"><a :href="href" x-on:click.prevent="play" x-show="!playing" class="aspect-video group block w-full max-w-full" rel="noopener" target="_blank">${playButton}${image}</a>${iframe}</div>`;
}

export default replaceIframes;
